import React from "react";
import Context from "../../Context";
import StaffListRow from "../Essence/Staff/StaffListRow";
import StaffListRowPicker from "../Essence/Staff/StaffListRowPicker";
import ModelList from "../Layout/Model/ModelList";
import Blocker from "./Blocker";
import BsModal from "./BsModal";
import List from "./List";
import Modal from "./Modal";
import Searchbox from "./Searchbox";
export default class StaffPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      listKey: "",
      search: [],
      filters: [],
      fields: [],
      sortings: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listKey !== this.props.listKey) {
      this.setState({ listKey: this.props.listKey });
    }
  }

  handleSearch = (searchValue) => {
    let search = searchValue
      ? [
          {
            lstr: "(",
            field: "fullname",
            compare: "IKE",
            value: `%${searchValue}%`,
          },
          {
            field: "structurename",
            compare: "IKE",
            value: `%${searchValue}%`,
            condition: "OR",
          },
          {
            field: "positionname",
            compare: "IKE",
            value: `%${searchValue}%`,
            condition: "OR",
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  onStaffPick = (staffItem) => {
    if (this.props.onPick) {
      this.props.onPick(staffItem);
    }
  };

  render() {
    const ModalComponent = this.props.keepModal ? Modal : BsModal;

    return (
      <ModalComponent
        center
        show={this.props.show}
        onClose={this.props.onClose}
      >
        <Searchbox onSearch={this.handleSearch} />
        <List
          listKey={"staff"}
          key={this.state.listKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(this.state.filters)}
          sort={JSON.stringify(this.state.sortings)}
          fields={JSON.stringify(this.state.fields)}
          limit={10}
          keyField="id"
          path="/staff/list"
          multiselect
        >
          <StaffListRowPicker onStaffPick={this.onStaffPick} />
        </List>
      </ModalComponent>
    );
  }
}
